(function (global) {
  const FIELDS = 'resources[options][fields]=title,variants.sku';

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/-/g, ' ')
      .replace(/[áàâãä]/g, 'a')
      .replace(/[éèêë]/g, 'e')
      .replace(/[íìîï]/g, 'i')
      .replace(/[óòôõö]/g, 'o')
      .replace(/[úùûü]/g, 'u')
      .replace(/ç/g, 'c')
      .replace(/ñ/g, 'n')
      .replace(/[ýÿ]/g, 'y')
      .trim();
  }

  function productMatchesSearchTerm(term, title, skus) {
    const tokens = normalizeSearchText(term).split(/\s+/).filter(Boolean);

    if (tokens.length === 0) {
      return true;
    }

    const foldedTitle = normalizeSearchText(title);
    const foldedSkus = normalizeSearchText(Array.isArray(skus) ? skus.join(' ') : skus);
    const titleOk = tokens.every((token) => foldedTitle.includes(token));
    const skuOk = tokens.every((token) => foldedSkus.includes(token));

    return titleOk || skuOk;
  }

  global.elazSearchLiteral = {
    normalizeSearchText,
    productMatchesSearchTerm,
  };

  if (!global.window || typeof global.fetch !== 'function') {
    return;
  }

  const originalFetch = global.fetch.bind(global);

  global.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : input && input.url;

      if (url && url.indexOf('search/suggest') !== -1) {
        const next = url.replace(
          /resources(?:%5B|\[)options(?:%5D|\])(?:%5B|\[)fields(?:%5D|\])=[^&]*/i,
          FIELDS
        );
        const rewritten = next === url ? `${url}${url.indexOf('?') === -1 ? '?' : '&'}${FIELDS}` : next;

        if (typeof input === 'string') {
          return originalFetch(rewritten, init);
        }

        return originalFetch(new Request(rewritten, input), init);
      }
    } catch (error) {
      return originalFetch(input, init);
    }

    return originalFetch(input, init);
  };
})(globalThis);
